import React, { FC, useEffect } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { StudyOverviewDefaultRoute } from '../../study/container/StudyOverviewDefaultRoute';
import { useNavigationContext } from '../context/useNavigationContextState';
import { useMatchPaths } from '../hooks/useMatchPaths';
import { PathUtil } from '../util/PathUtil';
import { studyDocumentsRoutes } from '../../study-documents/page/studyDocumentsRoutes';
import { studyArchivingRoutes } from '../../study-archiving/page/studyArchivingRoutes';

const StudyOverviewRoot: FC = () => {
  const { setSelectedSubPath } = useNavigationContext();
  const matchedCspPath = useMatchPaths([
    CspPath.STUDY_OVERVIEW_OVERVIEW,
    CspPath.STUDY_OVERVIEW_DOCUMENTS,
    CspPath.STUDY_OVERVIEW_ARCHIVING_FILES,
    CspPath.STUDY_OVERVIEW_ARCHIVING_SITES,
  ]);

  useEffect(() => {
    if (matchedCspPath) {
      setSelectedSubPath(CspPath.STUDY_OVERVIEW, matchedCspPath);
    }
  }, [matchedCspPath, setSelectedSubPath]);

  return <Outlet />;
};

const StudyOverview = React.lazy(() => import('../../study/container/StudyOverviewContainer'));

export const StudyOverviewRoutes: RouteObject[] = [
  {
    element: <StudyOverviewRoot />,
    children: [
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW, CspPath.STUDY_OVERVIEW_OVERVIEW, true),
        element: <StudyOverview />,
      },
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW, CspPath.STUDY_OVERVIEW_DOCUMENTS, true),
        children: studyDocumentsRoutes,
      },
      {
        path: PathUtil.toRelativePath(CspPath.STUDY_OVERVIEW, CspPath.STUDY_OVERVIEW_ARCHIVING, true),
        children: studyArchivingRoutes,
      },
      {
        path: '',
        element: <StudyOverviewDefaultRoute />,
      },
    ],
  },
];
